// components/NotificationContainer.jsx
import React, { useEffect, useState } from 'react';
import { notificationManager } from '../services/notification.js';

const NotificationContainer = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    return notificationManager.subscribe(notification => {
      setNotifications(prev => [...prev, notification]);

      // Auto remove after duration
      if (notification.duration > 0) {
        setTimeout(() => {
          removeNotification(notification.id);
        }, notification.duration);
      }
    });
  }, []);

  const removeNotification = id => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  if (notifications.length === 0) return null;

  return (
    <div className='fixed top-4 right-4 z-50 space-y-2'>
      {notifications.map(notification => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onRemove={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  );
};

const NotificationItem = ({ notification, onRemove }) => {
  const { message, type } = notification;

  const typeStyles = {
    success: 'bg-green-500 text-white',
    error: 'bg-red-500 text-white',
    warning: 'bg-yellow-500 text-black',
    info: 'bg-blue-500 text-white',
  };

  const typeIcons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };

  return (
    <div
      className={`
      flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg min-w-80 max-w-96
      transform transition-all duration-300 ease-in-out animate-slide-in
      ${typeStyles[type] || typeStyles.info}
    `}
    >
      <span className='text-lg font-bold'>{typeIcons[type] || typeIcons.info}</span>
      <span className='flex-1 text-sm font-medium'>{message}</span>
      <button onClick={onRemove} className='text-lg font-bold opacity-70 hover:opacity-100 transition-opacity'>
        ×
      </button>
    </div>
  );
};

export default NotificationContainer;
